export const mapSegmentsUserInterviewIds = (project) => {
  const segmentsUserInterviewIds = {};
  project.segments.forEach(({
    id,
    userInterviewsProjectId,
    userInterviewsProjectCreatedAt,
    userInterviewsProjectLaunch,
    userInterviewsProjectLaunchAt,
  }) => {
    segmentsUserInterviewIds[id] = {
      userInterviewsProjectId,
      userInterviewsProjectCreatedAt,
      userInterviewsProjectLaunch,
      userInterviewsProjectLaunchAt,
    } || null;
  });
  return segmentsUserInterviewIds;
};
